__turbopack_context__.v({
  "Inner": "NearbySection-module-scss-module__ttasgW__Inner",
  "Top": "NearbySection-module-scss-module__ttasgW__Top",
  "TopActions": "NearbySection-module-scss-module__ttasgW__TopActions",
});
